<template>
   <div v-if="isVisible">
        <slot/>
   </div>
</template>

<script>
    export default {
        name: 'v-form-wizard-step',
        provide() {
            return {
                stepKey: this.stepKey,
            };
        },
        inject: ['registerStep', 'getContext'],
        props: {
            stepKey: {
                type: String,
                required: true,
            },
            stepName: String,
            optional: Boolean,
            disabled: Boolean,
            nextStepLabel: String,
            isSelfManaged: Boolean,
        },
        computed: {
            isVisible() {
                return this.stepKey === this.currentStepKey;
            },
            currentStepKey() {
                return this.currentStep && this.currentStep.stepKey;
            },
            currentStep() {
                return this.context && this.context.currentStep;
            },
        },
        data() {
            return {
                context: this.getContext(),
            };
        },
        methods: {
            register() {
                const step = {
                    stepKey: this.stepKey,
                    stepName: this.stepName,
                    optional: this.optional,
                    disabled: this.disabled,
                    nextStepLabel: this.nextStepLabel,
                    isSelfManaged: this.isSelfManaged,
                };
                this.registerStep(step);
            },
        },
        watch: {
            optional() {
                this.register();
            },
            disabled() {
                this.register();
            },
        },
        mounted() {
            this.register();
        },
    };
</script>
